import React from 'react';
import { Palette, Type, Layout, Download } from 'lucide-react';

const STEPS = [
  {
    icon: Palette,
    title: 'Choose your design',
    desc: 'Colors, fonts and visual style — make it match your aesthetic.',
  },
  {
    icon: Type,
    title: 'Add your content',
    desc: 'Text, details and personal touches that make the product yours.',
  },
  {
    icon: Layout,
    title: 'Arrange and personalize',
    desc: 'Customize sections, reorder pages and adjust the layout.',
  },
  {
    icon: Download,
    title: 'Export and use',
    desc: 'Download your finished product in print-ready quality.',
  },
];

export const CustomizationSection = ({ className = '' }) => (
  <section data-testid="customization-section" className={`py-16 md:py-24 ${className}`}>
    <div className="max-w-5xl mx-auto px-6 md:px-12">
      <div className="text-center mb-12">
        <p className="font-sans text-[10px] font-bold uppercase tracking-[0.25em] text-[#B49A88] mb-3">
          Personalization
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold text-stone-900 tracking-tight mb-4">
          Make it truly yours
        </h2>
        <p className="font-sans text-sm sm:text-base text-stone-500 max-w-lg mx-auto leading-relaxed">
          Every product is a starting point. Personalize the design, content and details to create something that feels like your own.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
        {STEPS.map((step, i) => (
          <div
            key={i}
            data-testid={`customization-step-${i}`}
            className="text-center group"
          >
            <div className="w-14 h-14 rounded-2xl bg-[#F7F5F2] mx-auto mb-4 flex items-center justify-center transition-colors group-hover:bg-[#EDE8E2]">
              <step.icon className="w-6 h-6 text-[#B49A88]" strokeWidth={1.5} />
            </div>
            <h3 className="font-serif text-sm font-bold text-stone-800 mb-2">{step.title}</h3>
            <p className="font-sans text-xs text-stone-400 leading-relaxed">{step.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
